import React from "react"
import { twMerge } from "tailwind-merge"

import Typography from "../../../components/shared/Typography"
import { ScrollReveal, ScrollRevealItem } from "../../WebsiteBuilderV2/components/shared/ScrollReveal"
import { CARD_IMAGE_HOVER_CLASSES } from "../../WebsiteBuilderV2/components/shared/scrollRevealVariants"

const ProCTASection = ({ isMobile = false }) => (
  <ScrollReveal as="section" variant="fadeIn" threshold={0.08} className="bg-white">
    <div className={`container mx-auto ${isMobile ? "w-full px-6 py-0" : "max-w-splash-container px-5 pb-10 pt-24"}`}>
      <div
        className={`overflow-hidden rounded-2xl border border-gray-light ${
          isMobile ? "flex flex-col" : "flex items-stretch md:flex-col"
        }`}
        style={{
          backgroundImage:
            "linear-gradient(97.09173292117964deg, rgb(var(--color-gradient-start)) 37.905%, rgb(var(--color-gradient-end)) 97.929%)"
        }}>
        <ScrollRevealItem
          staggerIndex={0}
          variant="scaleIn"
          className={`group relative shrink-0 overflow-hidden ${
            isMobile ? "aspect-[592/576] w-full" : "size-96 md:h-64 md:w-full"
          }`}>
          <img
            src="/images/homepage/pro-cta.webp"
            alt="Wellness practitioner"
            className={twMerge("absolute inset-0 size-full object-cover", CARD_IMAGE_HOVER_CLASSES)}
          />
        </ScrollRevealItem>

        <ScrollRevealItem
          staggerIndex={1}
          variant="fadeUp"
          className={`flex flex-1 items-center justify-center ${
            isMobile ? "px-8 py-10" : "px-[72px] py-12 md:px-6 md:py-8"
          }`}>
          <div className={`flex max-w-[640px] flex-col ${isMobile ? "w-full gap-8" : "gap-8"}`}>
            <div className={`flex flex-col ${isMobile ? "gap-3" : "gap-3"}`}>
              {isMobile ? (
                <h2 className="font-serif text-[32px] font-bold leading-[40px] text-black">
                  Wellness pro? Join the largest network of wellness practitioners
                </h2>
              ) : (
                <h2 className="font-serif text-[40px] font-bold leading-[48px] text-black md:text-3xl">
                  Wellness pro? Join the largest network of wellness practitioners.
                </h2>
              )}
              <Typography variant="body" className="text-black">
                Manage and grow your practice with the best-in-class tools for your business.
              </Typography>
            </div>
            <a
              href="/pro-platform"
              className={`w-fit rounded bg-teal transition-all hover:bg-teal-dark ${
                isMobile ? "px-4 py-0" : "px-4 py-3"
              }`}
              style={{
                ...(isMobile ? { height: "48px", display: "flex", alignItems: "center", justifyContent: "center" } : {})
              }}>
              <Typography variant="body" className="font-bold text-white">
                Join as a practitioner
              </Typography>
            </a>
          </div>
        </ScrollRevealItem>
      </div>
    </div>
  </ScrollReveal>
)

export default ProCTASection
